const avtoPathesHead = {
  city: (data, p) => ({
    title: `Автосалоны ${p.t(data.city)}. Все автодилеры, цены, акции на авто из салона - АвтоБазар`,
    description: `Автосалоны ${p.t(data.city)}. Лучшие предложения от автодилеров, скидки на новые автомобили. Запишитесь на тест-драйв ✅ адреса и телефоны автоцентра ☎️ на сайте АвтоБазар`,
    header: `Автосалоны ${p.t(data.city)}`,
    title_uk: `Автосалони ${p.t(data.city)}. Усі автодилери, ціни, акції на авто з салону - Автобазар`,
    description_uk: `Автосалони ${p.t(data.city)}. Кращі пропозиції від автодилерів, знижки на нові автомобілі. Запишіться на тест-драйв ✅ адреси і телефони автоцентру ☎️ на сайті Автобазар`,
    header_uk: `Автосалони ${p.t(data.city)}`,
  }),
  cityMake: (data, p) => ({
    title: `Автосалоны ${data.make} ${p.inCity}. Цены, акции на авто из салона - АвтоБазар`,
    description: `Автосалоны ${data.make} ${p.inCity}. Лучшие предложения от автодилеров ${data.make} на новые автомобили. Запишитесь на тест-драйв ✅ адреса и телефоны автоцентров ☎️ на сайте АвтоБазар`,
    header: `Автосалоны ${data.make} ${p.inCity}`,
    title_uk: `Автосалони ${data.make} ${p.inCity}. Ціни, акції на авто з салону - Автобазар`,
    description_uk: `Автосалони ${data.make} ${p.inCity}. Кращі пропозиції від автодилерів ${data.make} на нові автомобілі. Запишіться на тест-драйв ✅ адреси і телефони автоцентрів ☎️ на сайті Автобазар`,
    header_uk: `Автосалони ${data.make} ${p.inCity}`,
  }),
};

export default avtoPathesHead;



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/avto/templates.js